import React, { useEffect, useState } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import FichaTecnicaModal from './FichaTecnicaModalSubproducto';
import { ColumnGroup } from "primereact/columngroup";
const TableSubproductos = (
    {
        header,
        subproductos,
        loading,
        globalFilterValue,
        handleEditSubproducto,
        nombreEmpresa
    }
) => {
    const [showFichaModal, setShowFichaModal] = useState(false);
    const [selectedSubproductoFicha, setSelectedSubproductoFicha] = useState(null);
    const closeFichaModal = () => {
        setShowFichaModal(false);
        setSelectedSubproductoFicha(null);
    };
    const openFichaModal = (subproducto) => {
        setSelectedSubproductoFicha(subproducto);
        setShowFichaModal(true);
    };
    useEffect(() => {
        console.log(subproductos);
    }, [subproductos]);

return (
    <div>
    <DataTable 
        header={
            header
            ? header
            : `Se encontraron ${subproductos.length} subproductos`
        }
        value={subproductos}    
        className="p-datatable-gridlines"
        showGridlines
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate={`Mostrando {first} a {last} de {totalRecords} subproductos de ${nombreEmpresa}`}
        dataKey="id"
        loading={loading}
        emptyMessage="No se encontraron Subproductos."
        stripedRows="true"
        id="subproductosTable"
        globalFilter={globalFilterValue}
        globalFilterFields={["descripcion", "tarifa.tarifa_base"]}
        tableStyle={{
            tableLayout: "fixed",
            width: "100%",
            minWidth: "1000px",
        }}
        scrollHeight="57vh"
        scrollable
        reorderableColumns
        resizableColumns
        columnResizeMode="fit"
    >

        <Column 
            field="descripcion" 
            header="Descripción" 
            sortable
            style={{ width: '11%' }}
            bodyStyle={{ overflow: 'hidden' }}
            body={(rowData) => (
                <span
                    style={{
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    title={rowData.descripcion}
                >
                    {rowData.descripcion}
                </span>
            )}
        />

        <Column
            field="unidad"
            header="Unidad"
            sortable
            body={(rowData) => {
            if (rowData.unidad === "m**2") return "m²";
            if (rowData.unidad === "m**3") return "m³";
            return rowData.unidad;
            }}
        />

        <Column
            field="tarifa.tarifa_base"
            header="Tarifa"
            sortable
            body={(rowData) =>
            new Intl.NumberFormat("es-CL", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(rowData.tarifa?.tarifa_base ?? 0)
            }
        />


        <Column
            field="activo"
            header="Estados"
            body={(rowData) => (
            <>
                <div>
                    {rowData.activo ? (
                    <Button
                        icon="pi pi-check"
                        className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                        outlined
                        tooltip="subproducto activo"
                        tooltipOptions={{ position: 'top' }}
                    />
                    ) : (
                    <Button
                        icon="pi pi-times"
                        className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
                        onClick={() => {}}
                        outlined
                        tooltip="subproducto inactivo"
                        tooltipOptions={{ position: 'top' }}
                    />
                    )}
                </div>
            </>
            )}
            sortable
        />

        <Column
            header="Acciones"
            body={(rowData) => (
            <>
                <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
                label="Editar"
                outlined
                onClick={() => handleEditSubproducto(rowData)}
                />
                <Button
                icon="pi pi-file-o"
                className="p-button-rounded p-button-info p-button-outlined p-button mr-2 mb-2 mt-2"
                tooltip="Ver Ficha Técnica"
                label="Ficha"
                tooltipOptions={{ position: 'top' }}
                onClick={() => openFichaModal(rowData)}
                disabled={rowData.activo===0}
                />
            </>
            )}
        />

    </DataTable>
    <FichaTecnicaModal
        visible={showFichaModal}
        onHide={closeFichaModal}
        subproductoId={selectedSubproductoFicha?.id}
        subproductoDescripcion={selectedSubproductoFicha?.descripcion}
    />
    </div>
    );
};

export default TableSubproductos;
